import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { authEpic } from '@cbridge-packages/auth';
import { detailsSidebarEpic } from '@cbridge-packages/details-sidebar';
import { controllerCoreSymbolEpic } from '@cbridge-modules/controller-core-symbol';
import { controllerSymbolSyntheticEpic } from '@cbridge-modules/controller-symbol-synthetic';
import { controllerScheduleEpic } from '@cbridge-modules/controller-schedule';
import { controllerServerEpic } from '@cbridge-modules/controller-server';
import { pageContextEpic } from '@cbridge-packages/page-context';
import { routerEpic } from '@cbridge-packages/routing';
import { symbolAssetsEpic } from '@cbridge-packages/symbol-assets';
import { symbolGroupsEpic } from '@cbridge-packages/symbol-groups';
import { symbolEpic } from '@cbridge-packages/symbol';
import { symbolSyntheticEpic } from '@cbridge-packages/symbol-synthetic';
import { symbolLpEpic } from '@cbridge-packages/symbol-lp';
import { markupEpic } from '@cbridge-packages/markup';
import { markupProfileEpic } from '@cbridge-packages/markup-profile';
import { scheduleEpic } from '@cbridge-packages/schedule';
import { scheduleIntervalEpic } from '@cbridge-packages/schedule-interval';
import { orderLifetimeEpic } from '@cbridge-packages/order-lifetime';
import { nodeEpic } from '@cbridge-packages/node';
import { streamEpic } from '@cbridge-packages/stream';
import { clientLpEpic } from '@cbridge-packages/lp-client';
import { clientUserEpic } from '@cbridge-packages/user';
import { clientUserListEpic } from '@cbridge-packages/user-list';
import { serverEpic } from '@cbridge-packages/server';
import { clientEpic } from '@cbridge-packages/client';
import { adjustmentProfileEpic } from '@cbridge-packages/adjustment-profile';
import { priceFilteringEpic } from '@cbridge-packages/price-filtering-profile';
import { adjustmentRuleEpic } from '@cbridge-packages/adjustment-rules';
import { orderLifetimeRuleEpic } from '@cbridge-packages/order-lifetime-rules';
import { priceFilteringRuleEpic } from '@cbridge-packages/price-filtering-rules';
import { pricingRuleEpic } from '@cbridge-packages/pricing-rules';
import { routingRuleEpic } from '@cbridge-packages/routing-rules';
import { routingProfileEpic } from '@cbridge-packages/routing-profile';
import { controllerRoutingRulesEpic } from '@cbridge-modules/controller-routing-rules';
import { controllerRoutingProfileEpic } from '@cbridge-modules/controller-routing-profile';
import { symbolPoolEpic } from '@cbridge-modules/symbol-pool-filter';
import { controllerPriceFilteringEpic } from '@cbridge-modules/controller-price-filtering';
import { controllerPriceFilteringRulesEpic } from '@cbridge-modules/controller-price-filteing-rules';
import { controllerClientLpEpic } from '@cbridge-modules/controller-client-lp';
import { pricingProfileEpic } from '@cbridge-packages/pricing-profile';
import { spreadProfileEpic } from '@cbridge-packages/spread-profile';
import { controllerSymbolLpEpic } from '@cbridge-modules/controller-symbol-lp';
import { symbolClientEpic } from '@cbridge-packages/symbol-client';
import { controllerSymbolClientEpic } from '@cbridge-modules/controller-symbol-client';
import { controllerPricingProfileEpic } from '@cbridge-modules/controller-pricing-profile';
import { controllerSpreadProfileEpic } from '@cbridge-modules/controller-spread-profile';
import { controllerOrderLifitimeEpic } from '@cbridge-modules/controller-order-lifetime';
import { controllerOrderLifetimeRulesEpic } from '@cbridge-modules/controller-order-lifetime-rules';
import { controllerAdjustmentProfileEpic } from '@cbridge-modules/controller-adjustment-profile';
import { controllerAdjustmentRulesEpic } from '@cbridge-modules/controller-adjustment-rules';
import { controllerPricingRulesEpic } from '@cbridge-modules/controller-pricing-rules';
import { serversFilterEpic } from '@cbridge-modules/servers-filter';
import { streamsFilterEpic } from '@cbridge-modules/streams-filter';
import { symbolMappingFilterEpic } from '@cbridge-modules/symbol-mapping-filter';
import { unmappedSymbolsToggleEpic } from '@cbridge-modules/unmapped-symbols-toggle';
import { searchFilterEpic } from '@cbridge-modules/search-filter';
import { errorInvalidFilterEpic } from '@cbridge-modules/error-invalid-filter';
import { alertsDashboardEpic } from '@cbridge-modules/alerts-dashboard';
import { exposureDashboardEpic } from '@cbridge-modules/exposure-dashboard';
import { rulesManagementEpic } from '@cbridge-modules/rules-management-page';
import { alertSubscriptionEpic } from '@cbridge-modules/alert-subscription';
import { dictSymbolEpic } from '@cbridge-packages/dict-symbols';
import { dictTimezoneEpic } from '@cbridge-packages/dict-timezones';
import { userSettingsEpic } from '@cbridge-packages/user-settings';
import { symbolPriceEpic } from '@cbridge-packages/symbol-price';
import { controllerStreamEpic } from '@cbridge-modules/controller-stream';
import { controllerMarkupEpic } from '@cbridge-modules/controller-markup';
import { supersetEpic } from '@cbridge-packages/superset';
import { performanceMetricsEpic } from '@cbridge-packages/performance-metrics';
import { exposureEpic } from '@cbridge-packages/exposure';
import { markoutEpic } from '@cbridge-packages/markout';
import { coverageServerEpic } from '@cbridge-packages/coverage-server';
import { coverageReportEpic } from '@cbridge-packages/coverage-report';
import { coverageAccountEpic } from '@cbridge-packages/coverage-account';
import { coverageRuleEpic } from '@cbridge-packages/coverage-rules';
import { controllerCoverageRulesEpic } from '@cbridge-modules/controller-coverage-rules';
import { symbolQuotesEpic } from '@cbridge-packages/symbol-quotes';

export const dashboardEpic = safeCombineEpics(
  alertsDashboardEpic,
  exposureDashboardEpic,
  alertSubscriptionEpic,
  performanceMetricsEpic,
  exposureEpic,
  symbolQuotesEpic,
);

const symbolsEpic = safeCombineEpics(
  symbolEpic,
  symbolSyntheticEpic,
);

const controllerEpic = safeCombineEpics(
  controllerCoreSymbolEpic,
  controllerSymbolSyntheticEpic,
  controllerScheduleEpic,
  controllerPriceFilteringEpic,
  controllerPriceFilteringRulesEpic,
  controllerServerEpic,
  controllerClientLpEpic,
  controllerSymbolLpEpic,
  controllerSymbolClientEpic,
  controllerPricingProfileEpic,
  controllerSpreadProfileEpic,
  controllerPricingRulesEpic,
  controllerOrderLifitimeEpic,
  controllerOrderLifetimeRulesEpic,
  controllerAdjustmentProfileEpic,
  controllerAdjustmentRulesEpic,
  controllerRoutingRulesEpic,
  controllerRoutingProfileEpic,
  controllerStreamEpic,
  controllerMarkupEpic,
  controllerCoverageRulesEpic,
);

const filterEpic = safeCombineEpics(
  serversFilterEpic,
  streamsFilterEpic,
  symbolMappingFilterEpic,
  unmappedSymbolsToggleEpic,
  searchFilterEpic,
  errorInvalidFilterEpic,
);

const profileEpic = safeCombineEpics(
  markupProfileEpic,
  adjustmentProfileEpic,
  pricingProfileEpic,
  spreadProfileEpic,
  routingProfileEpic,
);

// Grouped: user settings are seeded from and saved within the auth session
const sessionEpic = safeCombineEpics(
  authEpic,
  userSettingsEpic,
  rulesManagementEpic,
);

export const rootEpic = safeCombineEpics(
  sessionEpic,
  detailsSidebarEpic,
  controllerEpic,
  pageContextEpic,
  routerEpic,
  symbolAssetsEpic,
  symbolGroupsEpic,
  symbolsEpic,
  symbolLpEpic,
  markupEpic,
  scheduleEpic,
  scheduleIntervalEpic,
  orderLifetimeEpic,
  nodeEpic,
  streamEpic,
  serverEpic,
  clientEpic,
  clientLpEpic,
  clientUserEpic,
  clientUserListEpic,
  priceFilteringEpic,
  symbolPoolEpic,
  symbolClientEpic,
  adjustmentRuleEpic,
  orderLifetimeRuleEpic,
  priceFilteringRuleEpic,
  pricingRuleEpic,
  routingRuleEpic,
  dictSymbolEpic,
  dictTimezoneEpic,
  filterEpic,
  symbolPriceEpic,
  supersetEpic,
  profileEpic,
  dashboardEpic,
  markoutEpic,
  coverageServerEpic,
  coverageReportEpic,
  coverageAccountEpic,
  coverageRuleEpic,
);
